export default {
  CHECK_MANAGEMENT(state, items) {
    state.items = items
  },

  CHECK_MANAGEMENT_TOTALS(state, totals) {
    state.totals = totals
  }
}
